var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Previewer_handleSetPositionByPreviewer, _Previewer_isPositionInNavigator, _Previewer_setNavigatorActivity, _Previewer_bindActions, _Previewer_initPreviewerContent, _Previewer_updatePreviewerContent, _Previewer_setBounds;
import { IMAGE_EXTENSION } from '../consts';
import { loadImageInstantly } from '../utils/helpers';
export class Previewer {
    constructor() {
        Object.defineProperty(this, "viewport", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "imageEl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "imageWrapperEl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mainContainerEl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "navigatorEl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "borderLineElT", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "borderLineElB", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "borderLineElL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "borderLineElR", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mainContainerBounds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "navigatorBounds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "tilesUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "isNavigatorActive", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        _Previewer_handleSetPositionByPreviewer.set(this, (e, isAnimated = false) => {
            if (!this.mainContainerBounds)
                return;
            const posX = ((e.clientX - this.mainContainerBounds.x) / this.mainContainerBounds.width) * 100;
            const posY = ((e.clientY - this.mainContainerBounds.y) / this.mainContainerBounds.height) * 100;
            if (this.viewport) {
                if (isAnimated) {
                    this.viewport?.setPositionByPercentageAnimated(50 - posX, 50 - posY);
                }
                else {
                    this.viewport.setPositionByPercentage(50 - posX, 50 - posY);
                }
            }
        });
        _Previewer_isPositionInNavigator.set(this, (x, y) => {
            if (!this.navigatorBounds) {
                console.error('no navigator bounds found');
                return false;
            }
            return (x >= this.navigatorBounds.x &&
                x <= this.navigatorBounds.x + this.navigatorBounds.width &&
                y >= this.navigatorBounds.y &&
                y <= this.navigatorBounds.y + this.navigatorBounds.height);
        });
        _Previewer_setNavigatorActivity.set(this, (isActive) => {
            this.isNavigatorActive = isActive;
        });
        _Previewer_bindActions.set(this, () => {
            this.mainContainerEl.onclick = (e) => {
                __classPrivateFieldGet(this, _Previewer_handleSetPositionByPreviewer, "f").call(this, e, true);
            };
            this.navigatorEl.onmousedown = () => {
                __classPrivateFieldGet(this, _Previewer_setNavigatorActivity, "f").call(this, true);
            };
            this.navigatorEl.onmouseup = () => {
                __classPrivateFieldGet(this, _Previewer_setNavigatorActivity, "f").call(this, false);
            };
            this.mainContainerEl.onmouseleave = () => {
                __classPrivateFieldGet(this, _Previewer_setNavigatorActivity, "f").call(this, false);
            };
            this.mainContainerEl.onmousemove = (e) => {
                if (this.isNavigatorActive) {
                    __classPrivateFieldGet(this, _Previewer_handleSetPositionByPreviewer, "f").call(this, e);
                }
            };
            this.mainContainerEl.ontouchstart = (e) => {
                if (__classPrivateFieldGet(this, _Previewer_isPositionInNavigator, "f").call(this, e.touches[0].clientX, e.touches[0].clientY)) {
                    __classPrivateFieldGet(this, _Previewer_setNavigatorActivity, "f").call(this, true);
                }
            };
            this.mainContainerEl.ontouchend = () => {
                __classPrivateFieldGet(this, _Previewer_setNavigatorActivity, "f").call(this, false);
            };
            this.mainContainerEl.ontouchmove = (e) => {
                if (this.isNavigatorActive) {
                    __classPrivateFieldGet(this, _Previewer_handleSetPositionByPreviewer, "f").call(this, e.touches[0]);
                }
            };
        });
        _Previewer_initPreviewerContent.set(this, () => {
            loadImageInstantly(`${this.tilesUrl}/0/0_0.${IMAGE_EXTENSION}`).then((image) => {
                image.style.height = '100%';
                image.style.float = 'left';
                image.draggable = false;
                this.imageEl = image;
                this.imageWrapperEl.appendChild(image);
            });
        });
        _Previewer_updatePreviewerContent.set(this, () => {
            requestAnimationFrame(() => {
                if (this.viewport) {
                    const viewportSizeW = this.viewport.VIEWPORT_SIZE_INITIAL.w;
                    const viewportSizeH = this.viewport.VIEWPORT_SIZE_INITIAL.h;
                    const origSizeW = this.viewport.layers.at(-1)?.width ?? 0;
                    const origSizeH = this.viewport.layers.at(-1)?.height ?? 0;
                    let sizeByW = viewportSizeW / 0.01 / origSizeW / this.viewport.zoomPercentage;
                    let sizeByH = viewportSizeH / 0.01 / origSizeH / this.viewport.zoomPercentage;
                    let posX = this.viewport.posPercentageX;
                    let posY = this.viewport.posPercentageY;
                    if (sizeByW > 1) {
                        sizeByW = 1;
                        posX = 0;
                    }
                    if (sizeByH > 1) {
                        sizeByH = 1;
                        posY = 0;
                    }
                    const borderWidthScaleW = 1 / sizeByW;
                    const borderWidthScaleH = 1 / sizeByH;
                    this.borderLineElT.style.transform = `scaleY(${borderWidthScaleH})`;
                    this.borderLineElB.style.transform = `scaleY(${borderWidthScaleH})`;
                    this.borderLineElL.style.transform = `scaleX(${borderWidthScaleW})`;
                    this.borderLineElR.style.transform = `scaleX(${borderWidthScaleW})`;
                    this.navigatorEl.style.transform = `translate(${-posX}%, ${-posY}%) scaleX(${sizeByW}) scaleY(${sizeByH})`;
                    __classPrivateFieldGet(this, _Previewer_setBounds, "f").call(this);
                }
            });
        });
        _Previewer_setBounds.set(this, () => {
            this.mainContainerBounds = this.mainContainerEl.getBoundingClientRect();
            this.navigatorBounds = this.navigatorEl.getBoundingClientRect();
        });
        Object.defineProperty(this, "init", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (viewport) => {
                this.viewport = viewport;
                this.viewport.setPreviewerCallback(__classPrivateFieldGet(this, _Previewer_updatePreviewerContent, "f"));
                __classPrivateFieldGet(this, _Previewer_initPreviewerContent, "f").call(this);
                __classPrivateFieldGet(this, _Previewer_updatePreviewerContent, "f").call(this);
                __classPrivateFieldGet(this, _Previewer_bindActions, "f").call(this);
                window.onresize = () => {
                    __classPrivateFieldGet(this, _Previewer_setBounds, "f").call(this);
                };
            }
        });
        Object.defineProperty(this, "getPreviewer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.mainContainerEl;
            }
        });
        const borderColor = '#BCBCBC';
        const imageWrapper = document.createElement('div');
        const mainContainer = document.createElement('div');
        const navigator = document.createElement('div');
        const borderLineT = document.createElement('div');
        const borderLineB = document.createElement('div');
        const borderLineL = document.createElement('div');
        const borderLineR = document.createElement('div');
        mainContainer.style.position = 'relative';
        mainContainer.style.overflow = 'hidden';
        imageWrapper.style.position = 'relative';
        imageWrapper.style.display = 'flex';
        imageWrapper.style.justifyContent = 'center';
        imageWrapper.style.maxHeight = '100%';
        imageWrapper.style.maxWidth = '100%';
        navigator.style.width = '100%';
        navigator.style.height = '100%';
        navigator.style.position = 'absolute';
        navigator.style.top = '0';
        navigator.style.left = '0';
        navigator.style.boxShadow = '0px 0px 0px 10000px rgba(0, 0, 0, 0.4)';
        borderLineT.style.position = 'absolute';
        borderLineB.style.position = 'absolute';
        borderLineL.style.position = 'absolute';
        borderLineR.style.position = 'absolute';
        borderLineT.style.background = borderColor;
        borderLineL.style.background = borderColor;
        borderLineR.style.background = borderColor;
        borderLineB.style.background = borderColor;
        borderLineT.style.height = '1px';
        borderLineB.style.height = '1px';
        borderLineL.style.width = '1px';
        borderLineR.style.width = '1px';
        borderLineT.style.width = '100%';
        borderLineB.style.width = '100%';
        borderLineL.style.height = '100%';
        borderLineR.style.height = '100%';
        borderLineT.style.top = '0';
        borderLineB.style.bottom = '0';
        borderLineL.style.left = '0';
        borderLineR.style.right = '0';
        borderLineT.style.left = '0';
        borderLineB.style.left = '0';
        borderLineL.style.top = '0';
        borderLineR.style.top = '0';
        navigator.appendChild(borderLineT);
        navigator.appendChild(borderLineB);
        navigator.appendChild(borderLineL);
        navigator.appendChild(borderLineR);
        mainContainer.appendChild(imageWrapper);
        mainContainer.appendChild(navigator);
        this.mainContainerEl = mainContainer;
        this.imageWrapperEl = imageWrapper;
        this.navigatorEl = navigator;
        this.borderLineElT = borderLineT;
        this.borderLineElB = borderLineB;
        this.borderLineElL = borderLineL;
        this.borderLineElR = borderLineR;
    }
}
_Previewer_handleSetPositionByPreviewer = new WeakMap(), _Previewer_isPositionInNavigator = new WeakMap(), _Previewer_setNavigatorActivity = new WeakMap(), _Previewer_bindActions = new WeakMap(), _Previewer_initPreviewerContent = new WeakMap(), _Previewer_updatePreviewerContent = new WeakMap(), _Previewer_setBounds = new WeakMap();
